

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import '../user.css';
import { userManagementGetById } from '../user.service';

const UserView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const [userData, setuserData] = useState({});
    useEffect(() => {
        getUserManagementData();
    }, []);

    const getUserManagementData = async () => {
        try {
            const data = await userManagementGetById(id);
            setuserData(data.data);
        } catch (error) {
            console.error('Error fetching user type by ID', error);
        }
    };

    return (
        <Box display="flex" flexDirection="column" minHeight="85vh">
            <Grid container alignItems={'center'}>
                <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3 }}>
                    <Typography style={{ fontSize: 26, fontWeight: 700 }}>View User</Typography>
                </Grid>
                <Grid size={{ xs: 6, sm: 7.5, md: 8.5, lg: 8.5, xl: 8.5 }} textAlign={'end'}>
                </Grid>
                <Grid size={{ xs: 2, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }} textAlign={'end'}>
                    <Icon icon="ei:arrow-left" data-testid="back-button" onClick={() => navigate('/user')} width="30" height="30" className='backIcon'  />

                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={2}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentLeft'>First Name</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentRight'>:&nbsp; &nbsp; {userData?.firstName ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentLeft'>User Type</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.userTypeName ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={2}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentLeft'>Last Name  </Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.lastName ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentLeft'>Administrative Region   </Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.administrativeRegionName ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={2}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentLeft'>Phone Number</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.phoneNumber ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentLeft'> Last Mile Administrative Unit </Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentRight'> :&nbsp; &nbsp;  {userData?.lastMileUnitName ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={2}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentLeft'>Email</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.email ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentLeft'> Administrative Unit Name</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                            <Typography className='contentRight'> :&nbsp; &nbsp;  {userData?.administrativeUnitName ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={2}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={6}>
                            <Typography className='contentLeft'>Initiative Ecosystem to Join </Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography className='contentRight'>:&nbsp; &nbsp; {userData?.initiativeName ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={6}>
                            <Typography className='contentLeft'>Block </Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.block ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={2}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={6}>
                            <Typography className='contentLeft'>Payment Method </Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.preferredPaymentMethod ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={6}>
                            <Typography className='contentLeft'>Pincode </Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.pincode ?? "-" }</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>


            <Grid container mt={2} rowGap={2}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={6}>
                            <Typography className='contentLeft'>Subscription Plan </Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography className='contentRight'> :&nbsp; &nbsp;  {userData?.subscriptionPlanName ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={6}>
                            <Typography className='contentLeft'>Status </Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography className='contentRight'>:&nbsp; &nbsp;  {userData?.approvalStatus ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={2}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={6}>
                            <Typography className='contentLeft'>Ecosystem Integrator</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography className='contentRight'> :&nbsp; &nbsp;  {userData?.ecosystemIntegrator ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default UserView;
